import { useState, useEffect } from 'react';

export function useScreenSize() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [deviceType, setDeviceType] = useState(getDeviceType(window.innerWidth));

  function getDeviceType(width) {
    if (width < 768) return 'mobile';
    if (width < 1024) return 'tablet';
    return 'desktop';
  }

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenWidth(width);
      setDeviceType(getDeviceType(width));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { screenWidth, deviceType };
}
